import React from 'react';

import { Progress } from '@tolstoy/ui-library/core';

interface ProgressBarProps {
  progress: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => (
  <div className="flex flex-col items-center justify-center w-full h-full">
    <Progress value={progress} className="w-3/4 mb-2" />
    <p className="text-sm text-gray-600 dark:text-gray-400">{Math.round(progress)}%</p>
    <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">Processing...</p>
  </div>
);

export default ProgressBar;
